<template>
  <div>
    <p>Para poder participar debe tener al menos 5 alumnos inscritos.</p>
    <v-btn color="primary" @click="imprimirInscritos(0, 0, 1)">Imprimir listado</v-btn>
  </div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    loading: false,
    datos: [],
    registro: {},
    grado: '',
    asesor: {}
  }),
  created () {
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
  },
  methods: {
    imprimirInscritos () {
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.API}inscritos.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Inscritos.vue